import React, { useState, useEffect } from "react";
// import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import axiosInCar from "../../Redux/axios/AxiosInCar";
import {
  quick_quotes,
  QuickQuote_Post,
  Err_quotes,
  quick_quoteValues,
} from "../../Redux/actions/NumCaration";
import { insuranceproduct } from "../../Redux/actions/NumCaration";
import { Button, Form, Radio, message } from "antd/lib";
import moment from "moment";
export default function CarPrevpolictype({ setIsModalOpen }) {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state?.cardetail?.carnum);
  const vechicleData = useSelector((state) => state?.common?.vahanData);
  const QuickQuotes = useSelector((state) => state?.cardetail?.quickquotes);
  console.log("QuickQuotes", QuickQuotes);
  const QuickQuotePost = useSelector(
    (state) => state?.cardetail?.quickQuotePost
  );
  const QuoteInput = useSelector((state) => state?.cardetail?.quoteInput);
  console.log(QuickQuotePost);
  // const [QuotePost, setQuotePost] = useState(QuickQuotePost)
  const [loading, setLoading] = useState(false);
  const [product, setproduct] = useState([]);

  useEffect(() => {
    dispatch(insuranceproduct())
      .then((res) => {
        setproduct(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [dispatch]);
  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    // setValue(e.target.value);
  };
  const onFinish = (values) => {
    console.log("product values", values);
    const productcode = values.product;

    const registrationDate = moment(QuickQuotePost?.registrationDate).format(
      "YYYY-MM-DD"
    );
    const regDate = new Date(registrationDate);
    regDate.setFullYear(regDate.getFullYear() + 3);

    const updateQuoteInput = {
      ...QuoteInput,
      insuranceProductCode: productcode,
      productCode:
        productcode === "Not_Secure"
          ? "PVT"
          : productcode === "Bundled"
          ? "PVS"
          : productcode,
      ncbvalue:
        productcode === "Not_Secure" || productcode === "PVT"
          ? ""
          : QuoteInput?.ncbvalue,
    };

    let currentTP = {
      currentThirdPartyPolicyNumber:
        productcode === "PVS" || productcode === "Bundled"
          ? vechicleData?.insurance_policy_number
          : null,
      currentThirdPartyPolicyInsurerCode:
        productcode === "PVS" || productcode === "Bundled" ? "115" : null,
      currentThirdPartyPolicyStartDateTime:
        productcode === "PVS" || productcode === "Bundled"
          ? moment(QuickQuotePost.registrationDate).format("YYYY-MM-DD")
          : null,
      currentThirdPartyPolicyExpiryDateTime:
        productcode === "PVS" || productcode === "Bundled"
          ? moment(regDate).format("YYYY-MM-DD")
          : null,
    };
    const updatedQuotePost = {
      ...QuickQuotePost,
      previousPolicyExpiryDate:
        productcode === "Not_Secure"
          ? moment(new Date()).format("YYYY-MM-DD")
          : QuickQuotePost?.previousPolicyExpiryDate,
      product_code:
        productcode === "Not_Secure"
          ? "PVT"
          : productcode === "Bundled"
          ? "PVS"
          : productcode,
      currentThirdPartyPolicy:
        productcode === "PVS" || productcode === "Bundled" ? currentTP : null,
      originalPreviousPolicyType:
        productcode === "PVS"
          ? "1OD_0TP"
          : productcode === "Bundled"
          ? "1OD_3TP"
          : null,
      previousInsurerCode: productcode === "Not_Secure" ? null : "115",
      isPreviousInsurerKnown: productcode === "Not_Secure" ? 0 : 1, //0 r 1 int
    };
    console.log(updatedQuotePost);
    setLoading(true);
    axiosInCar
      .post(
        `v2/car_insurances/${auth?.car_insurance_id}/quick_quotes`,
        updatedQuotePost
      )
      .then((res) => {
        if (res.status === 200) {
          const Udata = res?.data?.data;
          //console.log("data-----------------",data)
          const errData = Udata?.filter(
            (item) => "status" in item && item.status === "failed"
          );
          dispatch(Err_quotes(errData));
          const filteredData = Udata?.filter(
            (item) => "status" in item && item.status === "success"
          );
          const updatedData = filteredData?.map((item) => ({
            ...item,
            IsGst: true,
          }));
          dispatch(quick_quotes(updatedData));

          dispatch(QuickQuote_Post(updatedQuotePost));
          dispatch(quick_quoteValues(updateQuoteInput));
          setLoading(false);
          setIsModalOpen(false);
          // } else {
          // message.error(res.data.error.validationMessages.join(","));
          // }
        }
      })
      .catch((err) => {
        console.log(err.response.data.error);
        setLoading(false);
        message.error(err.response.data.error);
      });
  };
  return (
    <>
      <Form onFinish={onFinish} layout="vertical" requiredMark={false}>
        <Form.Item
          name="product"
          label="It will help us to provide accurate quotes for you"
          rules={[
            {
              required: true,
              message: "Please select Policy Type",
            },
          ]}
          initialValue={QuoteInput?.insuranceProductCode}
        >
          <Radio.Group
            className="py-3 px-3 pb-0 bg-white ant-radio-layout prev-prod-sec"
            onChange={onChange}
          >
            {/* {product.map((e) => (
                  <Radio
                  key={e.id} value={e.product_code}>
                    {e.product_name}
                  </Radio>
                ))} */}
            <Radio value="PVP">Private Car Comprehensive</Radio>
            <Radio value="PVT">Private Car TP only</Radio>
            <Radio value="PVS">Private Car SAOD</Radio>
            <Radio value="Bundled">Bundled 1+3 Policy</Radio>
            <Radio value="Not_Secure">Not Secure</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item style={{ textAlign: "center" }}>
          <Button
            type="primary"
            htmlType="submit"
            className="update-qut-button"
            loading={loading}
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
